import { Container } from "../../../shared";

const cardsData = [
  {
    id: 1,
    title: "Drone Delivery Network",
    description: "Last-mile delivery program expanding to 50 cities in 2026",
    image: "https://images.unsplash.com/photo-1508610048659-a06b669e3321",
  },
  {
    id: 2,
    title: "Agri-Drone Initiative",
    description: "Precision agriculture across 2M hectares of farmland",
    image: "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee",
  },
  {
    id: 3,
    title: "Pilot Training Academy",
    description: "Over 12,000 certified pilots trained under DGCA norms",
    image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
  },
];

const CardItem = ({ card }) => {
  return (
    <div className="relative h-40 rounded-lg overflow-hidden group cursor-pointer mb-4">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-105"
        style={{ backgroundImage: `url(${card.image})` }}
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />

      {/* Content */}
      <div className="absolute bottom-0 px-3 py-0 text-white">
        <h3 className="text-sm font-semibold leading-none">{card.title}</h3>
        <p className="text-[11px] text-gray-200">{card.description}</p>
      </div>
    </div>
  );
};
const Cards = ({ data = cardsData }) => {
  return (
    <section>
      <Container>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {data.map((card) => (
            <CardItem key={card.id} card={card} />
          ))}
        </div>
      </Container>
    </section>
  );
};

export default Cards;
